export default __webpack_public_path__ + "static/media/Amper_photo_01.832b3f05.jpg";